import { kv } from '@vercel/kv';
import { ENV } from '../constants/environments';

const defaultConfig = {
  useCachingInDevEnv: false,
};

export default async function cache(
  key: string,
  seconds: number,
  fn: () => Promise<any>,
  config: { useCachingInDevEnv: boolean } = defaultConfig,
): Promise<any> {
  if (ENV.environment == 'development' && !config.useCachingInDevEnv) {
    return await fn();
  }

  const cacheKey = ENV.environment + '_' + key;
  try {
    const result = await kv.get(cacheKey);
    if (result == null) {
      throw new Error('cache miss');
    }
    return result;
  } catch (error) {
    const result = await fn();
    await kv.setex(cacheKey, seconds, result);
    return result;
  }
}
